module.exports = window["pro-gallery"];